module.exports = __webpack_public_path__ + "static/media/progress.4d884950.svg";